import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";

export class Shrine extends UnitType {
    readonly id = "shrine";
    readonly displayName = "Shrine";
    description() { return "Repels Fiends and Imps."; }
    maxCooldown() { return 0; }
    make() { return new GameObj("neutral", "shrine"); }
}
